import url from 'url';
import crypto from 'crypto';
import store from '@/store';

function removeWebSafe(safeEncodedString) {
  return safeEncodedString.replace(/-/g, '+').replace(/_/g, '/');
}

function makeWebSafe(encodedString) {
  return encodedString.replace(/\+/g, '-').replace(/\//g, '_');
}

function decodeBase64Hash(code) {
  return Buffer.from(code, 'base64');
}

function encodeBase64Hash(key, data) {
  return crypto.createHmac('sha1', key).update(data).digest('base64');
}

export default function googleApiSignature(urlToSign) {
  const uri = url.parse(urlToSign);
  const safeSecret = decodeBase64Hash(removeWebSafe(store.getters['system/googleMapsSecret']));
  const hashedSignature = makeWebSafe(encodeBase64Hash(safeSecret, uri.path));

  return url.format(`${urlToSign}&signature=${hashedSignature}`);
}
